import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Pagination, PageHeader, paginate } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate, search } from "../../../Common";
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { DairyCollectionDetailedReportSchema } from "../DairyCollectionDetailedReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import '../../../Common/Table/table.css';
import MaterialTable from "material-table";
import moment from 'moment';
import { object } from 'prop-types';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPDF';
import { Collections } from '@material-ui/icons';
import xlsx from 'json-as-xlsx';
import { TableContentForDairyCollectionDetailedReport } from '../../../Common/Table/tableContent';
import _ from 'lodash';
import '../Pages/tableFooter.css';
import $ from "jquery";

const screenCode = 'DAIRYCOLLECTIONDETAILEDREPORT'


const useStyles = makeStyles({
    card: {
        width: "100%"
    },
});
export function DairyCollectionDetailedReport(props) {

    const classes = useStyles();
    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [collectionCategory, setCollectionCategory] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [csvTotalRow, setCsvTotalRow] = useState([]);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionPointID: "0",
        date: ""

    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(DairyCollectionDetailedReportSchema).options({ allowUnknown: true });
    const [data, setdata] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [reportData, setReportData] = useState([]);
    const [isViewTable, setIsViewTable] = useState(true);
    const [columeNames, setColumeNames] = useState([]);
    const [densityTotal, setDensityTotal] = useState([]);
    const [fatTotal, setFatTotal] = useState([]);
    const [weightTotal, setWeightTotal] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const inishialColumName = ["firstName", "registrationNumber", "weightReadTime", "tagNumber", "density", "fat", "grossAmount"];
    const initalCsvHeaders = [
        { label: "Name", value: "firstName" },
        { label: "Reg No", value: "registrationNumber" },
        { label: "Time", value: "weightReadTime" },
        { label: "Tag No", value: "tagNumber" },
        { label: "Density", value: "density" },
        { label: "Fat", value: "fat" },
        { label: "Weight", value: "grossAmount" },
    ]
    const [contentRowNames, setContentRowNames] = useState([]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        company: "",
        date: "",
    });

    const [csvHeaders, setCsvHeaders] = useState([]);

    function setSelectedSearchData() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchData.groupID],
            company: operationEntity[searchData.operationEntityID],
            collectionpoint: collectionPoint[searchData.collectionPointID],
            date: searchData.date
        })
    }

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPointsForDropDown()
        )
        checkDisbursement();
    }, [searchData.operationEntityID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDAIRYCOLLECTIONDETAILEDREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, DairyCollectionDetailedReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
    }

    const convertFrom24To12Format = (time24) => {
        var timeSplit = time24.split(":");
        return timeSplit[0] + ":" + timeSplit[1];
    }


    async function handleSearch(e) {
        const errorMessages = validate(schema, searchData)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return;

        const reportData = await service.getDairyCollectionDetailedReport(searchData.collectionPointID, searchData.operationEntityID, searchData.date);
        calTotalVloume(reportData)
        ResultData(reportData)
        setSelectedSearchData();

        var totRecord = {
            firstName: "Total",
        };

        reportData.forEach((x, i) => {
            for (const item in x) {
                if ((item) !== "firstName" && (item) !== "registrationNumber" && (item) !== "weightReadTime" && (item) !== "tagNumber") {
                    totRecord[item] = (totRecord[item] === undefined ? 0 : parseFloat(totRecord[item])) + parseFloat(x[item]);
                }
            }
        });
        setCsvTotalRow(totRecord);
        if (reportData.length > 0) {
            setIsTableHide(false);
            checkDisbursement();
        }

    }
    function ResultData(data) {
        var result = [];
        data.forEach(function (e) {

            let time = convertFrom24To12Format(e.weightReadTime.split('T')[1].split('.')[0]);

            var prop = {
                firstName: e.firstName,
                registrationNumber: e.registrationNumber,
                weightReadTime: time,
                tagNumber: e.tagNumber,
                density: e.density.toFixed(2),
                fat: e.fat.toFixed(2),
                grossAmount: e.grossAmount.toFixed(2)
            }
            result.push(prop);

        }, {});
        setReportData(result)
        return result;
    }


    async function calTotalVloume(data) {
        if (data != null || data != undefined) {
            const densityTotal = data.reduce((previousScore, currentScore, index) => previousScore + currentScore.density, 0);
            const fatTotal = data.reduce((previousScore, currentScore, index) => previousScore + currentScore.fat, 0);
            const weightTotal = data.reduce((previousScore, currentScore, index) => previousScore + currentScore.grossAmount, 0);

            setDensityTotal(densityTotal.toFixed(2));
            setFatTotal(fatTotal.toFixed(2));
            setWeightTotal(weightTotal.toFixed(2));
        }
    }

    function checkDisbursement() {
        if (searchData.date === '') {
            setIsViewTable(true);
        }
        else {
            setIsViewTable(false);
        }
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }
    function createDataTable() {
        $("#reportTable").DataTable({
            scrollX: true
        });
    }

    function createFile() {
        var settings = {
            sheetName: 'Dairy Collection Detailed',
            fileName: 'DairyCollectionDetailed',
            writeOptions: {}
        }

        var copyOfCsv = _.cloneDeep(reportData)
        copyOfCsv.push(csvTotalRow)

        copyOfCsv.push({}, {
            firstName: "Group: " + selectedSearchValues.group,
            registrationNumber: "Factory: " + selectedSearchValues.company,
            weightReadTime: "Date: " + selectedSearchValues.date,
        });

        var copyOfCsv1 = _.cloneDeep(copyOfCsv)
        copyOfCsv1.push({
            firstName: "User: " + tokenService.getUserNameFromToken(),
            registrationNumber: "Generated Date/Time: " + new Date().toLocaleString(),
        });

        xlsx(initalCsvHeaders, copyOfCsv1, settings, true);
    }
    return (
        <Fragment>
            <CssBaseline />
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Dairy Collection Detailed Report"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Factory *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Factory--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Collection point *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Collection point--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>


                                <div className="col-md">
                                    <InputLabel shrink id="date">Date *</InputLabel>
                                    <TextField
                                        fullWidth
                                        id="date"
                                        name="date"
                                        type="date"
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["date"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["date"]}</FormHelperText>)}
                                </div>

                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>

                            <div className="row alternative_cls">
                                <div className="col pb-2 width4">
                                    <table hidden={isViewTable} className="display dataTable no-footer">
                                        <thead>
                                            <tr>
                                                <th rowSpan="2">Name</th>
                                                <th rowSpan="2">Reg No</th>
                                                <th rowSpan="2">Time</th>
                                                <th rowSpan="2">Tag No</th>
                                                <th rowSpan="2">Density</th>
                                                <th rowSpan="2">Fat</th>
                                                <th rowSpan="2">Weight</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <TableContentForDairyCollectionDetailedReport
                                                data={reportData}
                                                contentRowNames={inishialColumName}
                                                hasEdit={false}
                                            />
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th colSpan="1">Total</th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th style={{ textAlign: "right" }}>{densityTotal}</th>
                                                <th style={{ textAlign: "right" }}>{fatTotal}</th>
                                                <th style={{ textAlign: "right" }}>{weightTotal}</th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <hr />
                            </div>
                        </form>

                        <div className="pt-3" hidden={isViewTable}>
                            <ReactToPrint
                                trigger={() => <input
                                    type="button"
                                    className="btn btn-primary pull-right ml-2"
                                    value="Create PDF"
                                />}
                                content={() => componentRef.current}
                                documentTitle={'Dairy Collection Detailed Report'}
                            />
                            <div hidden={true}>
                                <CreatePdf ref={componentRef} data={reportData} rowNames={inishialColumName} densityTotal={densityTotal} fatTotal={fatTotal}
                                    weightTotal={weightTotal}
                                    searchData={selectedSearchValues} />
                            </div>
                            <input
                                type="button"
                                className="btn btn-primary pull-right ml-2"
                                value="Excel"
                                onClick={createFile}
                            />
                        </div>
                    </div>

                </div>
            </div>
        </Fragment >
    );
}



